import { adminApiFetch } from './apiService';

export const dashboardService = {
  // 獲取 Dashboard 設定
  getSettings: async () => {
    const response = await adminApiFetch('dashboard/settings.json', { method: 'GET' });
    return response.json();
  },

  // 保存 Dashboard 設定
  saveSettings: async (widgets) => {
    const response = await adminApiFetch('dashboard/settings.json', {
      method: 'POST',
      body: JSON.stringify({ widgets })
    });
    return response.json();
  }
};

export default dashboardService;
